(() => {
  'use strict';

  const STYLE_ID = 'vlinks-mobile-carousel-console-test';
  const MOBILE_QUERY = '(max-width: 767px)';
  const PRODUCT_NODE_SELECTOR = '.product-block[data-product-id]';
  const PRODUCT_SELECTOR = '.collection-listing .product-block[data-product-id]';
  const COLOR_FILTER_NAME = 'filter.v.m.custom.color_swatch';
  const HINT_DISTANCE_RATIO = 0.40;
  const HINT_DELAY = 650;
  const HINT_OUT_DURATION = 550;
  const HINT_HOLD_DURATION = 140;
  const HINT_RETURN_DURATION = 600;
  const mobileMedia = window.matchMedia(MOBILE_QUERY);

  if (!mobileMedia.matches) {
    console.warn('[VLINKS] הניסוי נעצר: יש לפתוח תצוגת מובייל ברוחב 767px ומטה ולרענן.');
    return;
  }

  if (!document.body.classList.contains('template-collection')) {
    console.warn('[VLINKS] הניסוי נעצר: הקוד מיועד לעמודי קטגוריה בלבד.');
    return;
  }

  window.__vlinksMobileCarouselTest?.destroy?.();

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    @media (max-width: 767px) {
      body.template-collection .vl-mobile-carousel-ready {
        overflow: hidden !important;
      }

      body.template-collection .vl-mobile-carousel-ready.vl-mobile-carousel-positioning
        .vl-mobile-carousel-track {
        visibility: hidden !important;
      }

      body.template-collection .vl-mobile-carousel-track {
        display: flex !important;
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        scroll-snap-type: x mandatory !important;
        scroll-behavior: auto !important;
        overscroll-behavior-x: contain;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;
      }

      body.template-collection .vl-mobile-carousel-track::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      body.template-collection .vl-mobile-carousel-track > .product-block__image {
        position: relative !important;
        inset: auto !important;
        display: block !important;
        flex: 0 0 100% !important;
        min-width: 100% !important;
        width: 100% !important;
        height: auto !important;
        opacity: 1 !important;
        transform: none !important;
        transition: none !important;
        scroll-snap-align: start !important;
        scroll-snap-stop: normal !important;
        pointer-events: auto !important;
      }

      body.template-collection .vl-mobile-carousel-track > .product-block__image--inactivated {
        display: block !important;
      }

      body.template-collection .vl-mobile-carousel-track > .product-block__image .theme-img {
        position: absolute !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
      }

      body.template-collection .vl-mobile-carousel-track.vl-mobile-carousel-hinting {
        scroll-snap-type: none !important;
      }
    }
  `;
  document.head.appendChild(style);

  const blockStates = new Map();
  const cleanup = [];
  let destroyed = false;
  let serverSyncTimer = 0;
  let serverSyncController = null;
  let lastServerSyncKey = '';
  let firstCardHintShown = false;

  const getParts = (block) => {
    const imageContainer = block.querySelector('.image-cont--with-secondary-image');
    const track = imageContainer?.querySelector('.image-label-wrap > div');
    return { imageContainer, track };
  };

  const getAllSlides = (block) => [
    ...block.querySelectorAll('.vl-mobile-carousel-track > .product-block__image')
  ];

  const getVisibleSlides = (block) => getAllSlides(block);

  const hasActiveColorFilter = () =>
    new URLSearchParams(location.search).has(COLOR_FILTER_NAME);

  const getActiveVisibleIndex = (block) => {
    const slides = getVisibleSlides(block);
    const index = slides.findIndex(
      (slide) => slide.classList.contains('product-block__image--active')
    );
    return index >= 0 ? index : 0;
  };

  const updateOriginalDots = (block, index) => {
    const dots = [...block.querySelectorAll('.product-block__image-dot')];
    if (!dots.length) return;

    const activeDotIndex = Math.min(Math.max(index, 0), dots.length - 1);
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('product-block__image-dot--active', dotIndex === activeDotIndex);
    });
  };

  const setActiveVisibleIndex = (block, index) => {
    getVisibleSlides(block).forEach((slide, slideIndex) => {
      slide.classList.toggle('product-block__image--active', slideIndex === index);
    });
    updateOriginalDots(block, index);
  };

  const closestVisibleIndex = (block, track) => {
    const slides = getVisibleSlides(block);
    if (!slides.length) return 0;

    const trackRect = track.getBoundingClientRect();
    const rtl = getComputedStyle(track).direction === 'rtl';
    const trackEdge = rtl ? trackRect.right : trackRect.left;
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const slideRect = slide.getBoundingClientRect();
      const slideEdge = rtl ? slideRect.right : slideRect.left;
      const distance = Math.abs(slideEdge - trackEdge);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  };

  const positionVisibleIndexNow = (block, index, behavior = 'auto') => {
    const state = blockStates.get(block);
    const slides = getVisibleSlides(block);
    const target = slides[index];
    if (!state || !target) return;

    if (destroyed || !target.isConnected) return;
    const trackRect = state.track.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const rtl = getComputedStyle(state.track).direction === 'rtl';
    const delta = rtl
      ? targetRect.right - trackRect.right
      : targetRect.left - trackRect.left;

    if (Math.abs(delta) > 1) {
      state.track.scrollBy({ left: delta, behavior });
    }
  };

  const scrollToVisibleIndex = (block, index, behavior = 'auto') => {
    requestAnimationFrame(() => positionVisibleIndexNow(block, index, behavior));
  };

  const alignToActiveImage = (block, behavior = 'auto') => {
    const index = getActiveVisibleIndex(block);
    updateOriginalDots(block, index);
    scrollToVisibleIndex(block, index, behavior);
  };

  const revealAllSlides = (block) => {
    getAllSlides(block).forEach((slide) => {
      slide.classList.remove('product-block__image--inactivated');
    });
  };

  const finishInitialPositioning = (block) => {
    const state = blockStates.get(block);
    if (!state || !state.imageContainer.classList.contains('vl-mobile-carousel-positioning')) {
      return;
    }

    const index = getActiveVisibleIndex(block);
    updateOriginalDots(block, index);
    positionVisibleIndexNow(block, index, 'auto');
    state.imageContainer.classList.remove('vl-mobile-carousel-positioning');
  };

  const scrollToMedia = (block, mediaId, behavior = 'smooth') => {
    revealAllSlides(block);

    const index = getAllSlides(block).findIndex(
      (slide) => slide.dataset.mediaId === mediaId
    );

    if (index < 0) {
      alignToActiveImage(block, behavior);
      return false;
    }

    setActiveVisibleIndex(block, index);
    scrollToVisibleIndex(block, index, behavior);
    return true;
  };

  const teardownBlock = (block) => {
    const state = blockStates.get(block);
    if (!state) return;

    clearTimeout(state.scrollEndTimer);
    cancelAnimationFrame(state.scrollFrame);
    state.cancelHint?.(false);
    state.imageContainer.removeEventListener('touchmove', state.stopOldSwipe, true);
    state.track.removeEventListener('scroll', state.onScroll);
    block.removeEventListener('click', state.onBlockClick);
    state.imageContainer.classList.remove(
      'vl-mobile-carousel-ready',
      'vl-mobile-carousel-positioning'
    );
    state.track.classList.remove('vl-mobile-carousel-track', 'vl-mobile-carousel-hinting');
    delete block.dataset.vlinksMobileCarouselTest;
    blockStates.delete(block);
  };

  const initBlock = (block) => {
    const { imageContainer, track } = getParts(block);
    const slides = track
      ? [...track.children].filter((element) => element.classList.contains('product-block__image'))
      : [];

    if (!imageContainer || !track || slides.length < 2) {
      teardownBlock(block);
      return false;
    }

    const previousState = blockStates.get(block);
    if (previousState?.track === track) return false;
    if (previousState) teardownBlock(block);

    imageContainer.classList.add('vl-mobile-carousel-ready');
    if (hasActiveColorFilter()) {
      imageContainer.classList.add('vl-mobile-carousel-positioning');
    }
    track.classList.add('vl-mobile-carousel-track');
    block.dataset.vlinksMobileCarouselTest = 'true';

    const state = {
      block,
      imageContainer,
      track,
      scrollEndTimer: 0,
      scrollFrame: 0,
      hinting: false,
      cancelHint: null,
      stopOldSwipe: null,
      onScroll: null,
      onBlockClick: null
    };

    state.stopOldSwipe = (event) => {
      if (mobileMedia.matches) event.stopImmediatePropagation();
    };

    state.onScroll = () => {
      if (state.hinting) return;

      cancelAnimationFrame(state.scrollFrame);
      state.scrollFrame = requestAnimationFrame(() => {
        updateOriginalDots(block, closestVisibleIndex(block, track));
      });

      clearTimeout(state.scrollEndTimer);
      state.scrollEndTimer = window.setTimeout(() => {
        const index = closestVisibleIndex(block, track);
        setActiveVisibleIndex(block, index);
      }, 100);
    };

    state.onBlockClick = (event) => {
      const swatch = event.target.closest('.product-block-options__item[data-media]');
      const arrow = event.target.closest('.image-page-button');
      if (!swatch && !arrow) return;

      const mediaId = swatch?.dataset.media;

      window.setTimeout(() => {
        if (mediaId) {
          scrollToMedia(block, mediaId, 'auto');
        } else {
          revealAllSlides(block);
          alignToActiveImage(block, 'smooth');
        }
      }, 0);
    };

    imageContainer.addEventListener('touchmove', state.stopOldSwipe, {
      capture: true,
      passive: true
    });
    track.addEventListener('scroll', state.onScroll, { passive: true });
    block.addEventListener('click', state.onBlockClick);
    blockStates.set(block, state);

    revealAllSlides(block);
    finishInitialPositioning(block);
    requestAnimationFrame(() => {
      alignToActiveImage(block, 'auto');
    });
    return true;
  };

  const initializeAll = (root = document) => {
    if (root instanceof Element && root.matches(PRODUCT_SELECTOR)) initBlock(root);
    root.querySelectorAll?.(PRODUCT_SELECTOR).forEach(initBlock);
  };

  const applyServerCardState = (liveBlock, serverBlock) => {
    const serverSlides = new Map(
      [...serverBlock.querySelectorAll('.product-block__image[data-media-id]')]
        .map((slide) => [slide.dataset.mediaId, slide])
    );
    const stateClasses = [
      'product-block__image--active',
      'product-block__image--inactivated',
      'product-block__image--primary',
      'product-block__image--secondary',
      'product-block__image--show-on-hover'
    ];

    liveBlock.querySelectorAll('.product-block__image[data-media-id]').forEach((liveSlide) => {
      const serverSlide = serverSlides.get(liveSlide.dataset.mediaId);
      if (!serverSlide) return;
      stateClasses.forEach((className) => {
        liveSlide.classList.toggle(className, serverSlide.classList.contains(className));
      });
    });

    const serverLinks = [...serverBlock.querySelectorAll('a[href*="/products/"]')];
    const liveLinks = [...liveBlock.querySelectorAll('a[href*="/products/"]')];
    liveLinks.forEach((liveLink, index) => {
      const serverHref = serverLinks[index]?.getAttribute('href');
      if (serverHref) liveLink.setAttribute('href', serverHref);
    });

    revealAllSlides(liveBlock);
    alignToActiveImage(liveBlock, 'auto');
  };

  const currentCollectionSignature = () => [
    location.href,
    ...[...document.querySelectorAll(PRODUCT_SELECTOR)].map(
      (block) => block.dataset.productId || ''
    )
  ].join('|');

  const syncCardsFromServer = async () => {
    if (destroyed || !hasActiveColorFilter()) return;

    const syncKey = currentCollectionSignature();
    if (syncKey === lastServerSyncKey) return;

    serverSyncController?.abort();
    serverSyncController = new AbortController();
    const requestedUrl = location.href;

    try {
      const response = await fetch(requestedUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'text/html' },
        signal: serverSyncController.signal
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      if (destroyed || requestedUrl !== location.href) return;

      const serverDocument = new DOMParser().parseFromString(html, 'text/html');
      const serverBlocks = new Map(
        [...serverDocument.querySelectorAll(PRODUCT_SELECTOR)].map(
          (block) => [block.dataset.productId, block]
        )
      );

      document.querySelectorAll(PRODUCT_SELECTOR).forEach((liveBlock) => {
        const serverBlock = serverBlocks.get(liveBlock.dataset.productId);
        if (serverBlock) applyServerCardState(liveBlock, serverBlock);
      });

      lastServerSyncKey = currentCollectionSignature();
      console.info('[VLINKS] תמונות הכרטיסים סונכרנו לתוצאת הסינון של Shopify.');
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn('[VLINKS] סנכרון תמונות הסינון נכשל:', error);
      }
    }
  };

  const scheduleServerSync = (delay = 300) => {
    clearTimeout(serverSyncTimer);
    serverSyncTimer = window.setTimeout(syncCardsFromServer, delay);
  };

  const showFirstCardHint = () => {
    if (firstCardHintShown || destroyed) return;
    const firstBlock = [...document.querySelectorAll(PRODUCT_SELECTOR)]
      .find((block) => getVisibleSlides(block).length >= 2);
    const state = firstBlock && blockStates.get(firstBlock);
    if (!state) return;

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.55)) return;
      observer.disconnect();
      firstCardHintShown = true;

      const rtl = getComputedStyle(state.track).direction === 'rtl';
      const distance = state.track.clientWidth * HINT_DISTANCE_RATIO * (rtl ? -1 : 1);
      const startingPosition = state.track.scrollLeft;
      let finished = false;
      let startTimer = 0;
      let holdTimer = 0;
      let hintFrame = 0;

      const cancelOnInteraction = () => finishHint(false);

      const animateScroll = (from, to, duration, onComplete) => {
        cancelAnimationFrame(hintFrame);
        const startedAt = performance.now();

        const step = (now) => {
          if (finished) return;

          const progress = Math.min((now - startedAt) / duration, 1);
          const eased = (1 - Math.cos(Math.PI * progress)) / 2;

          state.track.scrollTo({
            left: from + ((to - from) * eased),
            behavior: 'auto'
          });

          if (progress < 1) {
            hintFrame = requestAnimationFrame(step);
          } else {
            hintFrame = 0;
            onComplete?.();
          }
        };

        hintFrame = requestAnimationFrame(step);
      };

      const finishHint = (realign = true) => {
        if (finished) return;
        finished = true;
        clearTimeout(startTimer);
        clearTimeout(holdTimer);
        cancelAnimationFrame(hintFrame);
        state.track.removeEventListener('pointerdown', cancelOnInteraction, true);
        state.track.removeEventListener('touchstart', cancelOnInteraction, true);
        state.hinting = false;
        state.track.classList.remove('vl-mobile-carousel-hinting');
        state.track.scrollTo({ left: startingPosition, behavior: 'auto' });
        state.cancelHint = null;

        if (realign && firstBlock.isConnected) {
          alignToActiveImage(firstBlock, 'auto');
        }
      };

      state.cancelHint = finishHint;
      state.track.addEventListener('pointerdown', cancelOnInteraction, {
        capture: true,
        passive: true
      });
      state.track.addEventListener('touchstart', cancelOnInteraction, {
        capture: true,
        passive: true
      });

      startTimer = window.setTimeout(() => {
        if (finished || destroyed || !firstBlock.isConnected) {
          finishHint(false);
          return;
        }

        state.hinting = true;
        state.track.classList.add('vl-mobile-carousel-hinting');
        cancelAnimationFrame(state.scrollFrame);
        clearTimeout(state.scrollEndTimer);

        animateScroll(
          startingPosition,
          startingPosition + distance,
          HINT_OUT_DURATION,
          () => {
            holdTimer = window.setTimeout(() => {
              animateScroll(
                state.track.scrollLeft,
                startingPosition,
                HINT_RETURN_DURATION,
                () => finishHint(true)
              );
            }, HINT_HOLD_DURATION);
          }
        );
      }, HINT_DELAY);
    }, { threshold: [0.55] });

    observer.observe(firstBlock);
    cleanup.push(() => observer.disconnect());
  };

  initializeAll();
  if (hasActiveColorFilter()) {
    scheduleServerSync(0);
  }
  window.setTimeout(showFirstCardHint, 350);

  const collection = document.querySelector('.collection-listing');
  const mutationObserver = new MutationObserver((mutations) => {
    let productStructureChanged = false;

    mutations.forEach((mutation) => {
      if (mutation.type !== 'childList') return;

      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        initializeAll(node);
        const parentBlock = node.closest?.(PRODUCT_SELECTOR);
        if (parentBlock) initBlock(parentBlock);
        if (node.matches(PRODUCT_NODE_SELECTOR) || node.querySelector?.(PRODUCT_NODE_SELECTOR)) {
          productStructureChanged = true;
        }
      });

      mutation.removedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(PRODUCT_NODE_SELECTOR)) teardownBlock(node);
        node.querySelectorAll?.(PRODUCT_NODE_SELECTOR).forEach(teardownBlock);
        if (node.matches(PRODUCT_NODE_SELECTOR) || node.querySelector?.(PRODUCT_NODE_SELECTOR)) {
          productStructureChanged = true;
        }
      });
    });

    if (productStructureChanged) {
      initializeAll();
      lastServerSyncKey = '';
      scheduleServerSync(350);
    }
  });

  if (collection) {
    mutationObserver.observe(collection, { childList: true, subtree: true });
  }

  const onFilterChange = (event) => {
    if (!event.target.matches(`input[name="${COLOR_FILTER_NAME}"]`)) return;
    lastServerSyncKey = '';
    scheduleServerSync(900);
  };

  const onPopState = () => {
    lastServerSyncKey = '';
    scheduleServerSync(500);
  };

  document.addEventListener('change', onFilterChange, true);
  window.addEventListener('popstate', onPopState);

  window.__vlinksMobileCarouselTest = {
    version: '2.6.0',
    syncFilters: syncCardsFromServer,
    destroy() {
      destroyed = true;
      mutationObserver.disconnect();
      serverSyncController?.abort();
      clearTimeout(serverSyncTimer);
      document.removeEventListener('change', onFilterChange, true);
      window.removeEventListener('popstate', onPopState);
      cleanup.splice(0).forEach((fn) => fn());
      [...blockStates.keys()].forEach(teardownBlock);
      document.getElementById(STYLE_ID)?.remove();
      delete window.__vlinksMobileCarouselTest;
      console.info('[VLINKS] ניסוי הקרוסלה הוסר. יש לרענן כדי להחזיר את מצב התמונות המקורי במלואו.');
    }
  };

  console.info(
    `[VLINKS] ניסוי 2.6 הופעל ב-${blockStates.size} כרטיסים: סנכרון שרת רק עם פילטר צבע פעיל, פתיחה נקייה בקולקציות מסוננות, רמז תנועה של 40%, מעבר מיידי לצבע וגלילה חופשית.`
  );
})();